"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIdSwiper = _interopRequireDefault(require("react-id-swiper"));
require("swiper/css/swiper.css");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HotelOfferCell = _interopRequireDefault(require("../HotelOffersTable/HotelOfferCell"));
var _hotel = require("../../proptypes/hotel");
var _userflow = require("../../utils/userflow");
var _excluded = ["offers", "mealTypes", "nights", "onOfferClicked", "activeSlide", "onSlideChange", "isHotelOnly", "isWhiteLabel"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var config = {
  slidesPerView: 'auto',
  slidesPerColumnFill: 'row',
  centeredSlides: true,
  loop: false,
  longSwipesRatio: 2
};
var HotelOffersTableMobile = function HotelOffersTableMobile(_ref) {
  var offers = _ref.offers,
    mealTypes = _ref.mealTypes,
    nights = _ref.nights,
    onOfferClicked = _ref.onOfferClicked,
    activeSlide = _ref.activeSlide,
    onSlideChange = _ref.onSlideChange,
    isHotelOnly = _ref.isHotelOnly,
    isWhiteLabel = _ref.isWhiteLabel,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var swiperHandlers = (0, _react.useMemo)(function () {
    return {
      slideChange: function slideChange() {
        onSlideChange(this.activeIndex);
      }
    };
  });
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    swiper = _useState2[0],
    setSwiper = _useState2[1];
  var mealTypesCount = mealTypes.length;
  return /*#__PURE__*/_react["default"].createElement(StyledHotelOffersTableMobile, rest, /*#__PURE__*/_react["default"].createElement(_reactIdSwiper["default"], (0, _extends2["default"])({}, config, {
    key: mealTypesCount,
    slidesPerColumn: mealTypesCount,
    initialSlide: activeSlide,
    on: swiperHandlers,
    getSwiper: setSwiper
  }), mealTypes.map(function (_ref2, rowIdx) {
    var description = _ref2.description,
      id = _ref2.id;
    return nights.map(function (numOfNights, cloumnIdx) {
      return /*#__PURE__*/_react["default"].createElement(StyledItem, {
        key: "".concat(id, "-").concat(numOfNights),
        onOfferClicked: onOfferClicked,
        showNights: rowIdx === 0,
        nightsCount: numOfNights,
        isActive: cloumnIdx === activeSlide,
        mealType: description,
        onHeaderClicked: function onHeaderClicked() {
          return swiper.slideTo(cloumnIdx);
        },
        offers: (0, _userflow.getOffersByNights)(offers[id], numOfNights),
        startDate: (0, _userflow.getOffersStartDate)(offers[id][0]),
        isFirst: rowIdx === 0,
        isLast: rowIdx === mealTypesCount - 1,
        isHotelOnly: isHotelOnly,
        isWhiteLabel: isWhiteLabel
      });
    });
  })), /*#__PURE__*/_react["default"].createElement(StyledShadow, {
    position: "left"
  }), /*#__PURE__*/_react["default"].createElement(StyledShadow, {
    position: "right"
  }));
};
HotelOffersTableMobile.propTypes = {
  className: _propTypes["default"].string,
  activeSlide: _propTypes["default"].number,
  onOfferClicked: _propTypes["default"].func.isRequired,
  onSlideChange: _propTypes["default"].func.isRequired,
  mealTypes: _propTypes["default"].arrayOf(_hotel.MealTypePropTypes).isRequired,
  offers: _propTypes["default"].shape({}).isRequired,
  nights: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  selectedNights: _propTypes["default"].number.isRequired
};
HotelOffersTableMobile.defaultProps = {
  className: '',
  activeSlide: 0
};
var StyledItem = (0, _styledComponents["default"])(_HotelOfferCell["default"]).attrs({
  isMobile: true
}).withConfig({
  displayName: "HotelOffersTableMobile__StyledItem",
  componentId: "sc-1bz5p3o-0"
})(["height:auto !important;min-width:140px;max-width:140px;width:140px !important;border-top:", ";border-radius:", ";"], function (props) {
  return props.isFirst ? 'none' : '1px solid #d6d5c9';
}, function (props) {
  return props.isFirst ? '4px 4px 0 0' : props.isLast && '0 0 4px 4px' || 0;
});
var StyledHotelOffersTableMobile = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersTableMobile__StyledHotelOffersTableMobile",
  componentId: "sc-1bz5p3o-1"
})(["position:relative;"]);
var StyledShadow = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersTableMobile__StyledShadow",
  componentId: "sc-1bz5p3o-2"
})(["pointer-events:none;position:absolute;height:100%;width:30px;top:0;right:", ";left:", ";z-index:10;background-image:linear-gradient( to ", ",rgba(255,255,255,0),#fff );"], function (props) {
  return props.position === 'right' ? 0 : 'auto';
}, function (props) {
  return props.position === 'left' ? 0 : 'auto';
}, function (props) {
  return props.position;
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelOffersTableMobile);